var map = {
	"./locum/image1.png": 61356,
	"./locum/image2.png": 78176,
	"./locum/image3.png": 92037,
	"./locum/image4.png": 96758,
	"./pharmacy/image1.png": 13669,
	"./pharmacy/image2.png": 11902,
	"./pharmacy/image3.png": 80912,
	"./pharmacy/image4.png": 20522,
	"./us/locum/image1.png": 61491,
	"./us/locum/image2.png": 93061,
	"./us/locum/image3.png": 60623,
	"./us/locum/image4.png": 61566,
	"./us/pharmacy/image1.png": 60626,
	"./us/pharmacy/image2.png": 83359,
	"./us/pharmacy/image3.png": 38633,
	"./us/pharmacy/image4.png": 98483
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70497;